import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { CmsProductReferencesComponent, ConverterService, PRODUCT_NORMALIZER, Product, ProductReferenceService, UrlModule } from '@spartacus/core';
import { Observable } from 'rxjs';
import { distinctUntilChanged, filter, map, switchMap, take, tap, withLatestFrom } from 'rxjs/operators';
import { CmsComponentData, CurrentProductService, MediaModule } from "@spartacus/storefront";
import { GenProductReferencesComponent } from '../product-references/product-references.component';
import { GenProductTabReference } from 'src/app/generac/models/product.model';
import { GaItem, GenGoogleAnalyticsService } from 'src/app/generac/services/google-analytics.service';
import { GenBaseStoreService } from 'src/app/generac/services/base-store.service';
import { GenProductService } from 'src/app/generac/services/product.service';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { GenProductGridItemComponent } from '../product-list/product-grid-item/product-grid-item.component';
import { GenCarouselComponent } from 'src/app/generac/shared/components/carousel/carousel.component';
import { isEqual } from 'src/app/generac/shared/helpers/is-equal';

@Component({
    selector: 'gen-product-accessories',
    templateUrl: './product-accessories.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
      CommonModule,
      MediaModule,
      RouterModule,
      UrlModule,
      GenProductGridItemComponent,
      GenCarouselComponent,
    ],
})
export class GenProductAccessoriesComponent extends GenProductReferencesComponent {
  gaAccessories: GaItem[] = [];

  get viewAllLink$(): Observable<string | undefined> {
    return this.componentData$.pipe(map((data) => data?.viewAllLink));
  }

  constructor(
    override cmsComponentData: CmsComponentData<CmsProductReferencesComponent>,
    override currentProductService: CurrentProductService,
    baseStoreService: GenBaseStoreService,
    cdr: ChangeDetectorRef,
    override productReferenceService: ProductReferenceService,
    override googleAnalyticsService: GenGoogleAnalyticsService,
    protected productService: GenProductService,
    private converter: ConverterService,
  ) {
    super(cmsComponentData, currentProductService, baseStoreService, cdr, productReferenceService, googleAnalyticsService);
  }

  override get componentData$(): Observable<CmsProductReferencesComponent> {
    return this.cmsComponentData.data$.pipe(filter((data) => Boolean(data)));
  }

  itemsWithTabs$: Observable<GenProductTabReference[]> =
    this.productCode$.pipe(
      distinctUntilChanged(isEqual),
      withLatestFrom(this.componentData$),
      tap(([productCode, data]) => {
        this.gaListName = data.title;
      }),
      switchMap(([productCode, data]) =>
        this.getProductTabsReferences(productCode, data.productReferenceTypes ?? '')
      )
    );

  private getProductTabsReferences(productCode: string, referenceType: string): Observable<GenProductTabReference[]> {
    return this.productService.getProductTabReferences(productCode, referenceType).pipe(
      take(1),
      map((productTabReferences: GenProductTabReference[]) => {
        return productTabReferences.map(productTabReference => {
          if(productTabReference.tab == 'All') {
            this.googleAnalyticsService.sendViewItemListEvent(productTabReference.products, this.gaListName);
          };

          return {
            tab: productTabReference.tab,
            products: productTabReference.products.map((product: Product) => {
              return this.converter.convert({
                ...product,
                productCode: product.code,
              }, PRODUCT_NORMALIZER);
            }) as Product[],
          }
        })
      })
    )
  }
}
